/**
 * Global Application Constants
 */

export const APP_NAME = "Cyoa Brew";
export const APP_ID = "cyoa_brew"; // Технический ID для проверок
export const APP_VERSION = "1.2.4"; // Текущая версия

// Версия, ниже которой мы считаем сейвы "древними" и опасными
export const MIN_COMPATIBLE_VERSION = "1.0"; 